import "./index.css";
import logoImg from "assets/images/GO LOGO.svg";
import slideImg from "assets/images/SLIDE.svg";
import leaderboardImg from "assets/images/LEADERBOARD.svg";
import { testIds } from "enums/testIds";

/**
 * @name Header
 * @returns the header with the logo/leaderboard
 */
function Header({ className }) {
  return (
    <div
      className={`header ${className}`}
      data-testid={testIds.leaderboard_header}
    >
      <img src={logoImg} className={`logo ${className}`} alt="logo" />
      <img src={slideImg} className={`slash ${className}`} alt="slash" />
      <img
        src={leaderboardImg}
        className={`leaderboard ${className}`}
        alt="leaderboard"
      />
    </div>
  );
}

export default Header;
